import { render, staticRenderFns } from "./blogroll-details.vue?vue&type=template&id=f4559344&scoped=true&"
import script from "./blogroll-details.vue?vue&type=script&lang=js&"
export * from "./blogroll-details.vue?vue&type=script&lang=js&"
import style0 from "./blogroll-details.vue?vue&type=style&index=0&id=f4559344&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4559344",
  null
  
)

export default component.exports